//
// Based on https://github.com/googlemaps/js-markerclusterer/
// Rewritten to support bus tracker and data layer clustering
//

import { MarkerUtils } from "./MarkerUtils";

export interface DataClusterOptions{
    position?: google.maps.LatLng;
    lstPoints: google.maps.Data.Feature[];
}

//
// Data clusters are the data for points being shown on the map
//
// Normal points will have 1 item in its list of points and the display point will be that point
//    (Draws points normally)
//
// Clusters/Group points will have multiple items its list of points and the display point will
// be a special group point (created by Renderer). In other words the list of points is hidden (based on the zoom level and what overlaps)
// and only the display point is shown to represent overlapping points.
//
//
export class DataCluster{
    public DisplayPoint: google.maps.Data.Feature;
    public readonly lstPoints: google.maps.Data.Feature[];
    protected _position: google.maps.LatLng;

    constructor({ lstPoints, position } : DataClusterOptions){
        this.lstPoints = lstPoints;

        if(position){
            this._position = new google.maps.LatLng({ lat: position.lat(), lng: position.lng() });
        }
    }

    public get bounds(): google.maps.LatLngBounds | undefined{
        if(this.lstPoints.length == 0 && !this._position){
            return;
        }

        const bounds = new google.maps.LatLngBounds(this._position, this._position);
        for(const Point of this.lstPoints){
            bounds.extend(MarkerUtils.getPosition(Point));
        }

        return bounds;
    }

    public get position(): google.maps.LatLng{
        return this._position || this.bounds.getCenter();
    }

    public get count(): number{
        return this.lstPoints.filter((f: google.maps.Data.Feature) => MarkerUtils.getVisible(f)).length;
    }

    public push(Point: google.maps.Data.Feature): void{
        this.lstPoints.push(Point);
    }

    public delete(): void{
        if(this.DisplayPoint){
            MarkerUtils.setMap(this.DisplayPoint, null);
            this.DisplayPoint = undefined;
        }
        this.lstPoints.length = 0;
    }

}